import classNames from 'classnames';
import * as React from 'react';
import { useState } from 'react';
import NotificationsTrigger from '../../components/Notifications/NotificationsTrigger/withProvider';
import { useAppContext } from '../../hooks/useAppContext';
import HeaderSearchBar from '../HeaderSearchBar/container';
import GetADemoButton from './components/GetADemoButton';
import GlobalCreate from './components/GlobalCreate';
import HelpMenu from './components/HelpMenu';
import Logo from './components/Logo';
import NavigationTrigger from './components/NavigationTrigger';
import UserMenu from './components/UserMenu';

type Props = {
    toggleNavigation: () => void;
};

const AppHeader: React.FC<Props> = ({ toggleNavigation }) => {
    const [searchFocused, setSearchFocused] = useState(false);
    const { user } = useAppContext();
    const { companyColor } = user.company.companyDesignSettings;
    return (
        <div
            className={classNames('app-header-wrapper', { 'app-header-wrapper--search-focused': searchFocused })}
            style={{ borderColor: companyColor ?? undefined }}
        >
            <header role="banner" className="app-header">
                <NavigationTrigger toggleNavigation={toggleNavigation} />
                <Logo user={user} />
                <div className="app-header-actions">
                    {!user.isGuest && (
                        <>
                            <GetADemoButton user={user} />
                            <GlobalCreate user={user} />
                            <HeaderSearchBar
                                onFocus={() => setSearchFocused(true)}
                                onBlur={() => setSearchFocused(false)}
                            />
                        </>
                    )}
                    <HelpMenu />
                    <NotificationsTrigger />
                    <UserMenu user={user} />
                </div>
            </header>
        </div>
    );
};

export default AppHeader;
